import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/enrolmentsPageTab";
import deltas from "../../actions/deltas";

const {SET_ENROLMENTS_PAGE_TAB_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.ENROLMENTS_TAB, SET_ENROLMENTS_PAGE_TAB_STATE);

export const selectEnrolmentPageTab = (state) => state.states.enrolmentsPageTab.state;
